import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import BasicNumericInput from '../../../../../shared/components/formComponents/groups/BasicNumericInput';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicToggle from '../../../../../shared/components/formComponents/groups/BasicToggle';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

class ThisOrThatPermutationResultSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        assetLinkOptions: PropTypes.array,
        permutationQuestionDataSource: PropTypes.array,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, permutationQuestionDataSource, isGlobalSectionItem } = this.props;

        return (
            <div>
                <div className={'row'}>
                    <Field
                        name={
                            memberReference
                                ? `${memberReference}.content.questionSectionItemId`
                                : 'content.questionSectionItemId'
                        }
                        label={'Referenced A|B Question'}
                        options={permutationQuestionDataSource}
                        valueKey={'id'}
                        labelKey={'name'}
                        className={'col-4'}
                        component={BasicSelect}
                        disabled={isGlobalSectionItem}
                    />
                    <Field
                        name={memberReference ? `${memberReference}.content.resultsToShow` : 'content.resultsToShow'}
                        label={'Results to Show'}
                        minValue={1}
                        className={'col-2'}
                        component={BasicNumericInput}
                        disabled={isGlobalSectionItem}
                    />
                </div>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            readOnly={isGlobalSectionItem}
                            rows={3}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.isDraggable` : 'content.isDraggable'}
                        label={'Is Draggable?'}
                        className={'col-2'}
                        component={BasicToggle}
                        disabled={isGlobalSectionItem}
                        id={'is-draggable-toggle'}
                    />
                    <Field
                        name={memberReference ? `${memberReference}.content.showImage` : 'content.showImage'}
                        label={'Show Category Images?'}
                        className={'col-2'}
                        component={BasicToggle}
                        disabled={isGlobalSectionItem}
                        id={'show-category-images-toggle'}
                    />
                </div>
                <RichTextNotesHeader />
                <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
            </div>
        );
    }
}

export default ThisOrThatPermutationResultSectionItem;
